import { Column } from "@faire/web--source/slate/Layout";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import { getSpacing } from "@faire/web--source/slate/spacing";
import React, { Suspense } from "react";
import styled from "styled-components";

export const LazyDsaForm: React.FC = () => {
  return (
    <Suspense
      fallback={
        <LoadingSpinnerContainer>
          <LoadingSpinner size="large" />
        </LoadingSpinnerContainer>
      }
    >
      <LazyDsaFormBase />
    </Suspense>
  );
};

const LazyDsaFormBase = React.lazy<React.ComponentType>(() =>
  import(/* webpackChunkName: "dsa-form" */ "./DsaForm").then((module) => {
    return {
      default: module.DsaForm,
    };
  })
);

const LoadingSpinnerContainer = styled(Column).attrs({
  align: "center",
  justify: "center",
})`
  padding: ${getSpacing("8x")};
  width: width: min(100%, 690px);
`;
